export const contractors = {
  seo: {
    title: "Bespire kivitelezőknek és kertészeknek — AI asszisztens vállalkozóknak",
    description:
      "AI asszisztens építőipari és kertészeti vállalkozásoknak: saját weboldal referencia‑galériával, online felmérés‑foglalás, digitális árajánlatok, social media és Google hirdetések — egy helyen.",
  },
  hero: {
    badge: "Építőipar és kertészet",
    title: "Legyen neked is AI asszisztensed — kivitelezőknek és kertészeknek",
    subtitle:
      "Teljes körű AI asszisztens építőipari és kertészeti vállalkozóknak: segít vinni a napi teendőket, a marketinget, az árajánlatokat, az ügyfeleket és a foglalásokat — egy rendszerben.",
    ctaSecondary: "Ingyenes próba",
    imageAlt: "Építőipari kivitelező sisakban a munkaterületen",
    stats: [
      { value: "10 perc", label: "és használható üzleti eszközök a kezedben" },
      { value: "3 nap", label: "ingyenes próba" },
    ],
  },
  whatIs: {
    heading: "Mi az a Bespire?",
    description:
      "Egy AI asszisztens, ami segít vinni a vállalkozásod körüli munkát: marketing, ügyfelek, árajánlatok, foglalások és a napi teendők — hogy a szakmádra és a helyszínre tudj koncentrálni.",
    tiles: [
      {
        title: "AI asszisztens a napi munkádhoz",
        description:
          "Beszélgetve kérsz tőle posztot, hirdetésszöveget, árajánlat‑fogalmazást vagy napi teendőlistát — a csomagod része, nincs külön AI‑díj.",
      },
      {
        title: "Marketing automatikusan",
        description:
          "Egy fotó a kész munkáról, és az AI legyártja hozzá a Facebook, Instagram, TikTok posztot és a Google hirdetés szövegét.",
      },
      {
        title: "Weboldal, foglalás, ügyfelek egy helyen",
        description:
          "Saját weboldal referencia‑galériával, online felmérés‑foglalás, digitális árajánlatok és ügyfél‑nyilvántartás — 10 perc alatt használható eszközök.",
      },
    ],
  },
  dayInLife: {
    eyebrow: "Egy nap a Bespire‑rel",
    heading: "Így néz ki egy átlagos nap egy kivitelezőnél",
    subheading:
      "Nem elmélet — konkrét lépések, amiket az AI asszisztens levesz a válladról, hogy a szakmára koncentrálhass.",
    steps: [
      {
        time: "07:12",
        title: "Új felmérés‑kérés a weboldalról",
        description:
          "Miközben reggelizel, egy ügyfél lefoglal egy helyszíni felmérést jövő keddre — csak a szabad időpontok közül tudott választani.",
      },
      {
        time: "09:40",
        title: "Fotó a helyszínen → 3 platformon poszt",
        description:
          "Lefotózod a tegnap elkészült tetőfelújítást. Az AI Facebookra, Instagramra és TikTokra is legyártja a posztot hashtagekkel.",
      },
      {
        time: "12:15",
        title: "Digitális árajánlat sablonból",
        description:
          "Ebéd közben mobilról küldesz árajánlatot a délelőtti felmérésre. Az ügyfél megnyitja, és online el is fogadja.",
      },
      {
        time: "15:30",
        title: "AI megírja a jövő heti Google hirdetést",
        description:
          "„Írj hirdetést kerítésépítésre, május végi kampányra” — az AI 3 változatot ad, kiválasztod a legjobbat.",
      },
      {
        time: "18:00",
        title: "Nap vége — nulla papírmunka",
        description:
          "3 új ügyfél a CRM‑ben, 2 elfogadott árajánlat, holnapra tele a naptár. Egy Excel‑táblát sem nyitottál meg.",
      },
    ],
  },
  scenarios: {
    heading: "Ismerős a helyzet?",
    subheading:
      "3 konkrét forgatókönyv arra, mit vesz le a válladról a Bespire — attól függően, mivel foglalkozol.",
    items: [
      {
        role: "Kertépítő vállalkozás",
        title: "Elkészült egy szép kert — de senki nem látja",
        description:
          "A legszebb munkáid ott ülnek a telefonodon. A Bespire referencia‑galériába rakja, és minden kész projektről automatikusan posztot ír social médiára.",
        bullets: [
          "Előtte/utána galéria a weboldalon",
          "1 fotóból 3 platformra poszt",
          "Szezonális kampányok (tavasz, ősz) sablonból",
        ],
      },
      {
        role: "Építőipari kivitelező",
        title: "Napi 15 telefon időpont‑egyeztetésről",
        description:
          "Az ügyfelek maguk foglalnak helyszíni felmérést a weboldalon — csak a szabad időpontokból választhatnak. Utána az AI árajánlatot ír a jegyzeteid alapján.",
        bullets: [
          "Online felmérés‑foglalás a naptáradhoz kötve",
          "Árajánlat sablonok — 2 perc alatt kész",
          "Kártyás előleg opcionálisan",
        ],
      },
      {
        role: "Csapatot vezetsz",
        title: "Alvállalkozók, határidők, káosz",
        description:
          "Több felhasználót vehetsz fel jogosultságokkal — mindenki látja a saját napját, te pedig egy helyről követsz mindent. Intenzívebb napi használatra a Prémium csomag van optimalizálva.",
        bullets: [
          "Külön belépés a csapattagoknak",
          "Projekt‑nyilvántartás státusszal",
          "Automatikus emlékeztetők a határidőkről",
        ],
      },
    ],
  },
  inAction: {
    eyebrow: "A gyakorlatban",
    heading: "Így néz ki, amikor az ügyfeled találkozik veled",
    subheading:
      "Három konkrét pillanat, amit az ügyfél lát — profi benyomás, mindenféle IT‑tudás nélkül.",
    screens: [
      {
        title: "Weboldalad az ügyfél telefonján",
        description:
          "Galéria, szolgáltatások, „Helyszíni felmérést kérek” gomb — Google‑ban is megtalálnak.",
      },
      {
        title: "AI chat: „Írj posztot a mai munkáról”",
        description:
          "Beszélgetve mondod el, mit szeretnél. Az AI legyártja a posztot, te csak jóváhagyod.",
      },
      {
        title: "Digitális árajánlat, egy kattintással elfogadható",
        description:
          "Az ügyfél mobilon megnyitja, elolvassa és online elfogadja — látod, mikor nézte meg.",
      },
    ],
  },
  parallax: {
    alt: "Medence telepítése",
  },
  packages: {
    eyebrow: "Csomagok",
    heading: "Válaszd ki, melyik csomag illik a vállalkozásodhoz",
    subheading:
      "Havi vagy éves előfizetés — nettó árak, + ÁFA. Bármikor válthatsz vagy lemondhatod.",
    trialNote: "3 napig ingyen kipróbálhatod · Bankkártya nem szükséges · Bármikor lemondhatod",
    recommended: "Ajánlott",
    ctaPrimary: "Kipróbálom ingyen",
    ctaSecondary: "Kérek visszahívást",
    perMonth: "/ hó",
    perMonthShort: "/ hó",
    perYearShort: "/ év",
    savingLabel: "Éves megtakarítás",
    billingToggle: {
      monthly: "Havi",
      annual: "Éves",
      saveBadge: "2 hónap ingyen",
      annualHint: "Éves előfizetéssel 2 hónapot elengedünk — a havi ár × 10 az éves díj.",
    },
    items: [
      {
        name: "Növekedés",
        credits: "Kb. napi 5–10 AI‑feladat",
        features: [
          "Teljes rendszer: weboldal, foglalás, fizetés",
          "AI a napi munkádhoz — a csomag részeként",
          "Digitális árajánlatok és online fizetés",
          "Automatikus marketing eszközök",
        ],
        monthly: {
          price: "12 900 Ft + ÁFA",
        },
        annual: {
          price: "10 750 Ft + ÁFA",
          perYearLabel: "Éves díj: 129 000 Ft + ÁFA",
          saving: "25 800 Ft + ÁFA",
        },
      },
      {
        name: "Prémium",
        credits: "Napi 20+ AI‑feladat",
        features: [
          "Minden, ami a Növekedés csomagban — intenzívebb használatra optimalizálva",
          "Nagyobb terhelhetőség kampányidőszakban — akár napi 20+ AI‑feladat",
          "Prioritásos ügyfélszolgálat — gyorsabb válaszidő intenzív működéshez",
        ],
        monthly: {
          price: "24 900 Ft + ÁFA",
        },
        annual: {
          price: "20 750 Ft + ÁFA",
          perYearLabel: "Éves díj: 249 000 Ft + ÁFA",
          saving: "49 800 Ft + ÁFA",
        },
      },
    ],
  },
  benefits: {
    heading: "Miért éri meg kivitelezőként és kertészként?",
    items: [
      {
        title: "Saját weboldal referencia‑galériával",
        description:
          "Előtte/utána fotók, projektek, ügyfélvélemények — a jövőbeli megrendelők pontosan látják, mit tudsz. Google‑ban is optimalizált.",
      },
      {
        title: "Online felmérés‑foglalás",
        description:
          "A klienseid maguk kérnek helyszíni felmérést a weboldaladon — csak a szabad időpontokból választhatnak, nincs egyeztető telefonálás.",
      },
      {
        title: "Digitális árajánlatok",
        description:
          "Sablonokból pár perc alatt küldhetsz árajánlatot, láthatod ki nyitotta meg, és online el is fogadhatják.",
      },
      {
        title: "Ügyfél CRM és utánkövetés",
        description:
          "Minden érdeklődő, felmérés és projekt egy helyen — automatikus emlékeztetők a garanciás visszatérésre, éves karbantartásra.",
      },
      {
        title: "Marketing és social media",
        description:
          "Az AI legyártja a Facebook, Instagram, TikTok posztokat és a Google hirdetések szövegét — egy kész munka fotójából is.",
      },
      {
        title: "GDPR + EU szerver",
        description:
          "Az adataitokat EU‑s szervereken tároljuk, sosem használjuk AI tanításra, és nem adjuk el.",
      },
    ],
  },
  replaces: {
    heading: "Mit vált ki a Bespire?",
    description:
      "Külön weboldal, foglalási rendszer, közösségimédia‑menedzser és marketingügynökség helyett — egy AI asszisztens.",
    leftLabel: "Külön eszközök nélkül",
    rightLabel: "Bespire‑rel",
    unified: "Egyetlen rendszer — minden funkcióval együtt",
    aiBonus: "AI asszisztens — segít sikeresebb vállalkozóvá válni",
    rightItems: [
      "Weboldal + online felmérés‑foglalás",
      "Digitális árajánlatok és online fizetés",
      "Facebook, Instagram, TikTok posztok",
      "Google hirdetés szövegek és képek",
      "Ügyfél‑ és projekt‑nyilvántartás",
    ],
    items: [
      "Külön weboldal‑fejlesztő és domain kezelés",
      "Külön online foglalási / naptár rendszer",
      "Külön közösségimédia‑menedzser",
      "Külön marketingügynökség hirdetésekhez",
      "Excel táblák és papír árajánlatok",
    ],
  },
  continuousSupport: {
    eyebrow: "Támogatás",
    heading: "Nem maradsz egyedül az AI asszisztenssel",
    description:
      "Rendszeres workshopokat szervezünk kivitelezőknek és kertészeknek, ahol segítünk az AI asszisztens használatában, válaszolunk a felmerülő kérdésekre, és a vállalkozók egymással is megoszthatják az ötleteiket.",
    items: [
      {
        title: "Dedikált vállalkozói workshopok",
        description:
          "Rendszeres események kivitelezőknek és kertészeknek — ahol az AI asszisztens minden funkcióját közösen fedezhetitek fel.",
      },
      {
        title: "Élő kérdések és válaszok",
        description:
          "A felmerülő problémákra helyben válaszolunk — legyen szó weboldalról, árajánlatról vagy hirdetésekről.",
      },
      {
        title: "Gyakorlati asszisztenshasználat",
        description:
          "Konkrét tippek szezonális kampányokhoz, ajánlatokhoz és ügyfélszerzéshez — nem elmélet, hanem gyakorlat.",
      },
      {
        title: "Közösségi ötletmegosztás",
        description:
          "Tapasztalatcsere vállalkozóktól vállalkozóknak — hogyan használjátok a Bespire‑t a saját területeteken.",
      },
    ],
  },
  howToStart: {
    heading: "Hogyan indulsz?",
    subheading: "Két út közül választhatsz — mindkettőnél 3 napig ingyen próbálhatod.",
    paths: [
      {
        badge: "Magadtól",
        title: "Indulj ingyen 3 napos teljes hozzáféréssel",
        duration: "≈ 10 perc",
        description:
          "Regisztrálsz, és azonnal 3 napos teljes hozzáférést kapsz mindenhez — magad állítod be az AI asszisztenst, vagy eljöhetsz egy online workshopra.",
        steps: [
          "Regisztrálsz a Bespire‑ben",
          "3 napig mindent kipróbálhatsz — bankkártya nem szükséges",
          "Feltöltöd a referencia fotókat és szolgáltatásokat",
          "Élesíted a saját weboldalad — mehet az első felmérés",
        ],
        cta: "Kipróbálom ingyen",
        ctaHref: "/onboarding",
      },
      {
        badge: "Velünk",
        title: "Beüzemeljük neked",
        duration: "≈ 1 munkanap",
        description:
          "Visszahívunk, egyeztetjük a részleteket és mi állítjuk össze az AI asszisztensed — egyszeri 50 000 Ft + ÁFA beüzemelési díj ellenében. Te csak elkezded használni.",
        steps: [
          "Kérsz visszahívást",
          "Egyeztetjük az igényeidet telefonon",
          "Összerakjuk a weboldalt, foglalást, sablonokat",
          "Átadjuk kulcsrakészen — mehet az első ajánlat",
        ],
        cta: "Kérek visszahívást",
        ctaHref: "/smb-pricing#callback",
      },
    ],
  },
  faq: {
    heading: "Gyakori kérdések vállalkozóktól",
    items: [
      {
        q: "Kell hozzá informatikai tudás?",
        a: "Nem. Az AI asszisztens beszélgetve segít mindent beállítani — 10 perc alatt használható üzleti eszközök vannak a kezedben, sablonokból dolgozunk.",
      },
      {
        q: "Meglévő domainem is bekapcsolhatom?",
        a: "Igen. Használhatod a saját domainedet, vagy kapsz egy ingyenes aldomaint a Bespire‑ben.",
      },
      {
        q: "Mi történik a referencia fotóimmal?",
        a: "A képeidet EU‑s szervereken tároljuk, sosem használjuk AI tanításra, és nem adjuk tovább. Bármikor letöltheted vagy törölheted őket.",
      },
      {
        q: "Csapatnak, alvállalkozóknak is jó?",
        a: "Igen. Több felhasználót vehetsz fel jogosultságokkal — a helyszíni kollégák is láthatják a saját napjukat. Intenzív napi használatra a Prémium csomag van optimalizálva.",
      },
      {
        q: "Van felmondás?",
        a: "Bármikor lemondhatod, nincs hosszú távú elköteleződés — a következő fizetési ciklusig marad aktív.",
      },
      {
        q: "Mennyi a próbaidő?",
        a: "3 napig ingyen, teljes hozzáféréssel kipróbálhatod az AI asszisztenst és minden funkciót. Bankkártya nem szükséges, bármikor lemondhatod.",
      },
    ],
  },
  finalCta: {
    heading: "Kezdd el ingyen",
    description:
      "Indítsd el a Bespire‑t 3 napig ingyen, teljes hozzáféréssel — bankkártya nem szükséges, bármikor lemondhatod.",
    ctaPrimary: "Ingyenes indulás",
    ctaSecondary: "Beszéljünk telefonon",
  },
};
